export default __webpack_public_path__ + "static/media/information--stairs--g3.af1160fa.png";